import React, { Component } from "react";
import { Navbar, NavLink } from "library";

class GenericNavbar extends Component {
	render() {
		var logo = "https://mapquest-public.s3.amazonaws.com/21_01_01_17_41_26_icon_monster.jpg";

		var style = {
			boxShadow: "2px 2px 10px rgba(0,0,0,.1)",
			backgroundColor: "white",
			marginBottom: "10px",
		};

		var global_state = window.secret_react_state.getGlobalState();
		var user = global_state.user;

		return (
			<div>
				{!user || !("id" in user) ? (
					<Navbar style={style} logo={logo} name={"Forgotten Maps"} name_link={"/"}>
						<div></div>
						<NavLink href={"/login/"} name={"LOG IN"} />
					</Navbar>
				) : null}

				{user && "id" in user && !user.is_staff ? (
					<Navbar style={style} logo={logo} name={"Forgotten Maps"} name_link={"/"}>
						<NavLink href={"/"} name={"HOME"} />
						<NavLink href={"/my_groups/"} name={"My Groups"} />
						<NavLink href={"/my_locations/"} name={"My Locations"} />
						<NavLink href={"/logout/"} name={"LOG OUT"} />
					</Navbar>
				) : null}

				{user && "id" in user && user.is_staff ? (
					<Navbar style={style} logo={logo} name={"Forgotten Maps"} name_link={"/"}>
						<NavLink href={"/"} name={"HOME"} />
						<NavLink href={"/my_groups/"} name={"My Groups"} />
						<NavLink href={"/my_locations/"} name={"My Locations"} />
						<NavLink href={"/dm_tools/"} name={"DM Tools"} />
						<NavLink href={"/logout/"} name={"LOG OUT"} />
					</Navbar>
				) : null}
			</div>
		);
	}
}

export default GenericNavbar;
